import { motion } from "framer-motion";
import styled from "styled-components";

// ==================
// Stagger container - deca se pojavljuju jedno po jedno
// ==================
export const staggerContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.1,
    },
  },
};

export const staggerContainerSlow = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.15,
    },
  },
};

// ==================
// Child animation variants
// ==================
export const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
  },
};

export const fadeUpSmall = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] },
  },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.7, ease: "easeOut" },
  },
};

export const fadeLeft = {
  hidden: { opacity: 0, x: -40 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
  },
};

export const fadeRight = {
  hidden: { opacity: 0, x: 40 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
  },
};

export const scaleIn = {
  hidden: { opacity: 0, scale: 0.92 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] },
  },
};

export const lineReveal = {
  hidden: { scaleX: 0, originX: 0 },
  visible: {
    scaleX: 1,
    transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
  },
};

// ==================
// Reusable motion wrapper - scroll triggered stagger container
// ==================
const StaggerWrapperBase = styled(motion.div)``;

export function StaggerReveal({ children, slow, className, style }) {
  return (
    <StaggerWrapperBase
      className={className}
      style={style}
      variants={slow ? staggerContainerSlow : staggerContainer}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-80px" }}
    >
      {children}
    </StaggerWrapperBase>
  );
}

// ==================
// Motion item - child element sa default fadeUp
// ==================
export const MotionItem = styled(motion.div).attrs((props) => ({
  variants: props.$variants || fadeUp,
}))``;

// ==================
// Predefined animated text components
// ==================
export const MotionH1 = styled(motion.h1).attrs({ variants: fadeUp })``;
export const MotionH2 = styled(motion.h2).attrs({ variants: fadeUp })``;
export const MotionH3 = styled(motion.h3).attrs({ variants: fadeUp })``;
export const MotionP = styled(motion.p).attrs({ variants: fadeUpSmall })``;
export const MotionDiv = styled(motion.div).attrs({ variants: fadeUp })``;
